import { TEvent } from "@/types/event";
import { DayCellMountArg } from "@fullcalendar/core/index.js";
import { VerboseFormattingArg } from "@fullcalendar/core/internal";
import getEventActivityCategory from "./get-event-activity-category";

export const titleFormat = (date: VerboseFormattingArg) => {
  try {
    const monthDate = new Date();
    monthDate.setDate(1);
    monthDate.setMonth(date.start.month);
    const month = monthDate.toLocaleDateString("es-ES", {
      month: "long",
    });
    const year = date.start.year;
    return month + " • " + year;
  } catch {
    return ''
  }
};

export const eventContent = (event: any) => {
  try {
    if (event.el && event.view.type === "dayGridMonth") {
      event.el.classList.add("pointer-events-none");
      event.el.classList.add("sm:pointer-events-auto");
    }

    if (
      event.view.type === "timeGridWeek" ||
      event.view.type === "timeGridThreeDay" ||
      event.view.type === "timeGridTwoDay"
    ) {
      event.el.style.backgroundColor = getEventActivityCategory(
        event.event._def
      )?.color;
      event.el.style.border = "none";
      event.el.style.overflow = "hidden";
    }
  } catch { }
};

function twoDigits(n: number) {
  return String(n).padStart(2, "0");
}

export const validRange = () => {
  return {
    start: new Date(
      `${new Date().getFullYear()}-${twoDigits(new Date().getMonth() + 1)}-01`
    )
      .toISOString()
      .split("T")[0],
  };
};

export const dayCellDidMount = (
  event: DayCellMountArg,
  events: TEvent[],
  showPulse: boolean,
  showScroller = true
) => {
  try {
    const eventsContainer = event.el.querySelector(".fc-daygrid-day-events");

    event.el.classList.add("cursor-pointer");
    event.el.classList.add("sm:cursor-default");

    // if (showPulse) {
    //   const pulse = document.createElement("div");
    //   pulse.classList.add(
    //     "fc-pulse",
    //     "absolute",
    //     "top-0",
    //     "flex",
    //     "items-center",
    //     "justify-center",
    //     "w-full",
    //     "mt-2",
    //     "sm:hidden"
    //   );
    //   pulse.innerHTML = `<div class="absolute h-6 w-6 rounded-full animate-[circle-pulse_1.5s_ease-out_infinite] bg-primary-bg"></div>
    //         <div className="h-6 w-6 rounded-full"></div>`;

    //   eventsContainer?.appendChild(pulse);
    // }

    if (
      events.filter(
        (e) =>
          e.start.getDate() === event.date.getDate() &&
          e.start.getMonth() === event.date.getMonth() &&
          e.start.getFullYear() === event.date.getFullYear()
      ).length > 3 &&
      showScroller
    ) {
      const parent = eventsContainer?.parentElement
      if (!parent) return

      const existing = parent.querySelector('.fc-custom-scroll-notice')
      if (!existing) {
        const div = document.createElement("div");
        div.classList.add(
          "fc-custom-scroll-notice",
          "sticky",
          "w-full",
          "text-center",
          "bg-gradient-to-t",
          "from-accent",
          "to-white/90",
          "bottom-0",
          "z-100",
          "text-xs",
          "text-secondary-text",
          "shadow-sm",
          "p-1",
          "hidden",
          "sm:block"
        );
        div.innerText = "Desliza para ver más";

        parent.appendChild(div)

      }
    }
  } catch {

  }
};

export const slotLabelContent = (slot: any) => {
  return '';

  // try {
  //   return new Date(slot.date).toLocaleTimeString('es', { 'hour': '2-digit', timeZone: "Europe/Madrid" })
  // } catch {
  //   return '';
  // }
}

export const datesSet = (dayStart: string) => {
  for (let i = 0; i < document.getElementsByClassName('fc-timegrid-slot-label-cushion').length; i++) {
    const item = document.getElementsByClassName('fc-timegrid-slot-label-cushion').item(i);

    if (item) {
      item.textContent = (parseInt(dayStart.split(":")[0]) + i).toString().padStart(2, "0");
    }
  }
}
